import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'

const credentialTypes = ['customer-code', 'tl-customer-code'] as const
const locationCredentialTypes = ['customer-code', 'tl-customer-code'] as const

export type rbltCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const rbltDocumentTypes = [
  'invoice',
  'lumper-certificate',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const rblt: CarrierDef<rbltCredType> = {
  name: 'C.H. Robinson',
  scac: 'rblt',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    { id: 'guaranteed', name: 'Guaranteed', guaranteed: true },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [['customer-code', 'ref1']],
  credentialConfig: {
    'customer-code': { customerIdentifier: true },
    'tl-customer-code': { customerIdentifier: true },
  },
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'cancel',
    'documents',
    'tracking',
    'invoice',
  ],
  documentTypes: rbltDocumentTypes,
}
